import { render, staticRenderFns } from "./RWidgetInfo.vue?vue&type=template&id=099b2aea&scoped=true&"
import script from "./RWidgetInfo.vue?vue&type=script&lang=js&"
export * from "./RWidgetInfo.vue?vue&type=script&lang=js&"
import style0 from "./RWidgetInfo.vue?vue&type=style&index=0&id=099b2aea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b2aea",
  null
  
)

export default component.exports